import { useEffect, useRef, useState, useMemo, useContext } from "react";
// import { isnofferwallapi } from "../../config/axios/axiosconfig";
import { Link, useParams } from "react-router-dom";
// import { uuid } from "uuidv4";
// import PageHeader from "../../components/masterlayout/PageHeader";
// import "./profile.css";
import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../context/client/ClientContext";

import './common.css';
import { offerwallapi } from "../../config/axiosconfig";
import { LanguageContext } from "../../context/language/LanguageContext";
import { TenantContext } from "../../context/tenant/TenantContext";

export default function CommonProfile({ menuItem, CBRewardList, CBMerchantList, hidecommon, setLoader }) {
  const navigate = useNavigate();
  const { client } = useContext(ClientContext);
  const { language } = useContext(LanguageContext);
  const { tenant } = useContext(TenantContext);

  const params = useParams();
  const tenanturl = params.tenanturlpathname;

  const [accountColor, setAccountColor] = useState();
  const [cashbackColor, setCashbackColor] = useState();
  const [mycardsColor, setMyCardsColor] = useState();

  const [bonusCashback, setBonusCashback] = useState(0);
  const [firstExp, setFirstExp] = useState(null);
  const [availableSpin, setAvailableSpin] = useState(0);
  const [campaignId, setCampaignId] = useState("");


  const [cbBaseReward, setCBBaseReward] = useState(0);
  const [cbBonusReward, setCBBonusReward] = useState(0);
  const [copied, setCopied] = useState(false);



  const months = ["January", "Fabruary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  const color = useMemo(() => {
    if (menuItem === "MyCards") {
      setAccountColor("");
      setCashbackColor("");
      setMyCardsColor("isn-prof-selected-tab");
    } else if (menuItem === "Account") {
      setAccountColor("isn-prof-selected-tab");
      setCashbackColor("");
      setMyCardsColor("");
    } else {
      setCashbackColor("isn-prof-selected-tab");
      setAccountColor("");
      setMyCardsColor("");
    }
  }, [menuItem]);


  useEffect(() => {
    if (client && tenant && tenant?.tenantmasterconfig.gamification?.show) {
      getRewardInfo();
    }
    if (!tenant?.tenantmasterconfig.gamification?.show) {
      setLoader(false);
    }

  }, [client, tenant]);

  const getRewardInfo = async (camp_id) => {
    try {
      const res = await offerwallapi.get("/api/rewards/rewardinfo", {
        params: {
          tenantid: tenant.tenantid,
          clientid: client.clientid
        },
      });

      const rewards = res.data.rewards;
      const merchantList = res.data.merchantList;

      let baseReward = 0;
      let bonusReward = 0;

      await rewards?.map((rew, index) => {

        if (rew.rewardStatus === "REWARD ISSUED"
          || rew.rewardStatus === "CREDIT PENDING"
          || rew.rewardStatus === "CREDIT SUCCESSFUL") {
          (rew.reward_id) ?
            bonusReward = bonusReward + parseFloat(rew.bonusAmount)
            :
            baseReward = baseReward + parseFloat(rew.rewardAmount)

        }
        //



        if (language?.languagecode !== 'en') {

          // console.log("r.merchantTranslation", rew.merchantTranslation)
          if (rew.merchantTranslation) {
            try {
              const obj = JSON.parse(rew.merchantTranslation);
              obj?.map((merchantNameMul) => {
                if (merchantNameMul?.languageId == language?.languageid) {
                  rew.merchantName = merchantNameMul.name;
                  rewards[index] = rew;
                }
              });
            } catch (error) { console.log(error) }
          }


        }

      })
      setCBBaseReward(baseReward);
      setCBBonusReward(bonusReward);

      if (CBRewardList && CBMerchantList) {
        CBRewardList(rewards);
        if (language?.languagecode !== 'en') {
          merchantList?.map((merchant, index) => {
            if (merchant.merchantTranslation) {
              try {
                const obj = JSON.parse(merchant.merchantTranslation);
                obj?.map((merchantNameMul) => {
                  if (merchantNameMul?.languageId == language?.languageid) {
                    merchant.merchantName = merchantNameMul.name;
                    merchantList[index] = merchant;
                  }
                });
              } catch (error) { console.log(error) }
            }

          })
        }

        CBMerchantList(merchantList);
      }

      const res2 = await offerwallapi.post("/api/gamification/get-reward", {
        tenantid: tenant.tenantid,
        clientid: client.clientid

      });

      setBonusCashback(res2.data.bc);

      // const fxDate = new Date(new Date(res2.data.fxd).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' }));
      // const fxDateString = `${fxDate.getDate()}/${((fxDate.getMonth()) + 1) > 10 ? (fxDate.getMonth()) + 1 : '0' + (fxDate.getMonth() + 1)}/${fxDate.getFullYear()}`


      const fxDate2 = new Date(new Date(res2.data.fxd)).toLocaleDateString(tenant?.tenantmasterconfig.common.local_code, { year: "numeric", day: '2-digit', month: '2-digit' });

      const fxTime2 = new Date(new Date(res2.data.fxd)).toLocaleTimeString(language?.languagecodedatecommon, { hour: "2-digit", minute: "2-digit", hour12: true })

      const fxDateString2 = `${language?.static_labels.one_spin_expire.replace("[DATE]", fxDate2).replace("[TIME]", fxTime2)}`


      setFirstExp(res2.data.fxd ? fxDateString2 != 'undefined' ? fxDateString2 : null : null);

      setAvailableSpin(res2.data.asc);


      setCampaignId(res2.data.ci)
      // setCBBonusReward(res2.data.bc);

    } catch (error) { }
    setLoader(false);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(function () {
        setCopied(false);
      }, 2500);
    }).catch((err) => {
      console.error('Failed to copy: ', err);
    });
  };


  return (
    <div className={hidecommon}>
      <div className=" border rounded-3 h-100 d-none d-md-block">
        <div className="">
          <div className="isn-bradius bg-white pt-4">
            <div className="card mb-3 border-0">
              <div className="row g-0">
                <div class="border m-auto rounded-circle show " style={{
                  fontSize: "70px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "70px", height: "70px"
                }}>
                  <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblue.png`} className="d-block ms-auto me-auto" style={{ marginTop: "20px" }} />
                </div>
                {/* <div class="border m-auto rounded-circle show w-auto" type=""
                data-bs-toggle="dropdown" aria-expanded="true"
                style={{
                  fontSize: "70px", color: "#0265ad", backgroundColor: "#e7f5ff"
                }}>
                <i class="bi bi-person-circle h-100"></i>
              </div> */}
                <div className="text-center mt-3 fs-12 d-flex flex-column align-items-center">
                  <div>


                    <strong>{language?.static_labels.user_id}</strong>
                    <br />
                    {client?.externaluserid}
                    <span
                      data-toggle="tooltip"
                      title={language?.static_labels.copy}
                      style={{ paddingLeft: "5px", cursor: "pointer" }}
                      onClick={() => copyToClipboard(client?.externaluserid)}
                    >
                      <i className="bi bi-copy"></i>
                    </span>
                  </div>
                  {copied ? <div class="alert alert-success copy-to-clipboard-web" role="alert"> {language?.static_labels.copied_to_clipboard} </div> : null}
                </div>

                {
                  tenant?.tenantmasterconfig.gamification?.show ?
                    <div className="text-center mt-3 fs-12">
                      {
                        (availableSpin > 0) ?
                          <Link to={availableSpin > 0 ? `/${tenanturl}/gamification` : ``} state={{ campaignId: campaignId }} style={{ textDecoration: "none" }}>
                            <span className={`rounded-pill d-inline-block spinwheelremianbutton ${availableSpin > 0 ? `ow-primary-blue` : `ow-primary-gray`} fs-16`}>
                              <img style={{ width: "26px", marginBottom: "3px" }} src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`} />
                              <label className="ms-2 position-relative">
                                {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[0]}
                                <span style={{ fontWeight: "bold", fontSize: "1.4em" }}>{availableSpin}</span>
                                {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[1]}
                              </label>
                            </span>
                          </Link>
                          :
                          <span style={{ cursor: "default" }}>
                            <span className={`rounded-pill d-inline-block spinwheelremianbutton ${availableSpin > 0 ? `ow-primary-blue` : `ow-primary-gray`} fs-16`}>
                              <img style={{ width: "26px", marginBottom: "3px" }} src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`} />
                              <label className="ms-2 position-relative" >
                                {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[0]}
                                <span style={{ fontWeight: "bold", fontSize: "1.4em" }}>{availableSpin}</span>
                                {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[1]}
                              </label>
                            </span>
                          </span>

                      }

                      {/* <div className="mt-2 text-secondary fs-12">{language?.static_labels.sping_lable_remains}</div> */}
                      <div className="text-danger fs-11 mt-3 ps-4 pe-4" style={{ color: "#FF4823" }}>
                        {firstExp ? firstExp : ""}
                      </div>
                    </div>
                    : ""
                }


              </div>

              {
                tenant?.tenantmasterconfig.gamification?.show ?
                  <div className="p-3 fs-14">
                    <hr />
                    <div className="fw-bold">
                      {language?.static_labels.total_cashback} <label className="float-end">{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(cbBaseReward + cbBonusReward).toFixed(0)}</label>
                    </div>
                    <hr />
                    <div>
                      {language?.static_labels.base_cashback} <label className="float-end">{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(cbBaseReward).toFixed(0)}</label>
                    </div>
                    <hr />
                    <div>
                      {language?.static_labels.bonus_cashback} <label className="float-end">{tenant?.tenantmasterconfig.common.currency_symbol}{parseFloat(cbBonusReward).toFixed(0)}</label>
                    </div>
                  </div>
                  : ""
              }


            </div>

            {/* <hr /> */}
            <div className="mt-4">
              <div className={`border border-white isn-prof-tab ${accountColor} isn-fs-13`}>
                <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/account`}>


                  {/* <i style={{ fontSize: "16px", marginRight: "10px" }} className="bi bi-person"></i>  */}
                  {
                    (accountColor === "") ?
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblack.png`} className="me-3" style={{ width: "10px" }} />
                      :
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblue.png`} className="me-3" style={{ width: "10px" }} />
                  }
                  {language?.static_labels.myprofile}
                </Link>{" "}
              </div>
              <div className={`border border-white isn-prof-tab ${mycardsColor} isn-fs-13`}>
                <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/mycards`}>
                  {
                    (mycardsColor === "") ?
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cardblack.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                      :
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cardblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                  }

                  {/* <i style={{ fontSize: "16px", marginRight: "10px" }} className="bi bi-card-list"></i>  */}
                  {language?.static_labels.mycards}
                </Link>{" "}
              </div>
              <div className={`border border-white isn-prof-tab ${cashbackColor} isn-fs-13`}>
                <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/cashback`}>
                  {
                    (cashbackColor === "") ?
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblack2.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                      :
                      <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                  }

                  {language?.static_labels.cashback_overview}
                </Link>
              </div>

              {/* {
                tenant?.tenantmasterconfig.gamification?.show ?
                  <div className={`border border-white isn-prof-tab ${cashbackColor} isn-fs-13`}>
                    <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/cashback`}>
                      {
                        (cashbackColor === "") ?
                          <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblack2.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                          :
                          <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                      }

                      {language?.static_labels.cashback_overview}
                    </Link>
                  </div> : ""
              } */}

            </div>
          </div>
        </div>
      </div>





































      <div className=" border rounded-3 h-100 d-block d-md-none">
        <div className="">
          <div className="isn-bradius bg-white pt-4">



            <div className="overflow-auto pb-3 ps-2 pe-2" style={{ scrollbarWidth: "none" }}>
              <div className="" style={{ width: "max-content" }}>
                <div className={`border rounded-pill isn-prof-tab ${accountColor}-mob  fs-13 ps-2 pe-2 d-inline-block me-2`}>
                  <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/account`}>


                    {/* <i style={{ fontSize: "16px", marginRight: "10px" }} className="bi bi-person"></i>  */}
                    {
                      (accountColor === "") ?
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblack.png`} className="me-3" style={{ width: "10px" }} />
                        :
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblue.png`} className="me-3" style={{ width: "10px" }} />
                    }
                    {language?.static_labels.myprofile}
                  </Link>{" "}
                </div>
                <div className={`border rounded-pill isn-prof-tab ${mycardsColor}-mob  fs-13 ps-2 pe-2 d-inline-block me-2`}>
                  <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/mycards`}>
                    {
                      (mycardsColor === "") ?
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cardblack.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                        :
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cardblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                    }

                    {/* <i style={{ fontSize: "16px", marginRight: "10px" }} className="bi bi-card-list"></i>  */}
                    {language?.static_labels.mycards}
                  </Link>{" "}
                </div>
                <div className={`border rounded-pill isn-prof-tab ${cashbackColor}-mob fs-13 ps-2 pe-2 d-inline-block`}>
                  <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/cashback`}>
                    {
                      (cashbackColor === "") ?
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblack2.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                        :
                        <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                    }

                    {language?.static_labels.cashback_overview}
                  </Link>{" "}
                </div>

                {/* {
                  tenant?.tenantmasterconfig.gamification?.show ?
                    <div className={`border rounded-pill isn-prof-tab ${cashbackColor}-mob fs-13 ps-2 pe-2 d-inline-block`}>
                      <Link className="common-profile d-block fs-13" to={`/${tenanturl}/user/cashback`}>
                        {
                          (cashbackColor === "") ?
                            <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblack2.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                            :
                            <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/cashbackblue.png`} className="" style={{ width: "15px", marginRight: "11px" }} />
                        }

                        {language?.static_labels.cashback_overview}
                      </Link>{" "}
                    </div> : ""
                } */}

              </div>
            </div>




            <div className="card p-3 border-0">
              <div className="row">
                <div class="border m-auto rounded-circle show" style={{
                  fontSize: "70px", color: "#0265ad", backgroundColor: "#e7f5ff", width: "70px", height: "70px"
                }}>
                  <img src={`${process.env.REACT_APP_CLOUDFRONT}icons/manblue.png`} className="d-block ms-auto me-auto" style={{ marginTop: "20px" }} />
                </div>

                <div className="fs-12 ps-3 col" style={{ width: '50%' }}>
                  <div>
                    <strong>{language?.static_labels.user_id}</strong><br />
                    <div className="mobile-ext-id-view">
                      {client?.externaluserid}
                      <span className="mobile-ext-id-copy-icon" onClick={() => copyToClipboard(client?.externaluserid)} >
                        <i className="bi bi-copy"></i>
                      </span>

                    </div>
                  </div>
                  {copied ? <div className="alert alert-success copy-to-clipboard-mobile" role="alert"> {language?.static_labels.copied_to_clipboard} </div> : null}
                  {
                    tenant?.tenantmasterconfig.gamification?.show ?
                      <div className="mt-3 fs-12">
                        {
                          (availableSpin > 0) ?
                            <Link to={availableSpin > 0 ? `/${tenanturl}/gamification` : ``} state={{ campaignId: campaignId }} style={{ textDecoration: "none" }}>
                              <span className={`rounded-pill d-inline-block ps-2 pt-2 pb-2 pe-3 text-nowrap ${availableSpin > 0 ? `ow-primary-blue` : `ow-primary-gray`} fs-12`}>
                                <img style={{ width: "26px", marginBottom: "3px" }} src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`} />
                                <label className="ms-2 position-relative">
                                  {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[0]}
                                  <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>{availableSpin}</span>
                                  {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[1]}
                                </label>
                              </span>
                            </Link>
                            :
                            <span style={{ cursor: "default" }}>
                              <span className={`rounded-pill d-inline-block ps-2 pt-2 pb-2 pe-3 text-nowrap ${availableSpin > 0 ? `ow-primary-blue` : `ow-primary-gray`} fs-12`}>
                                <img style={{ width: "26px", marginBottom: "3px" }} src={`${process.env.REACT_APP_CLOUDFRONT}icons/spinwheelicon.svg`} />
                                <label className="ms-2 position-relative">
                                  {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[0]}
                                  <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>{availableSpin}</span>
                                  {language?.static_labels.sping_lable_spins.split("[SPIN_COUNT]")[1]}
                                </label>

                              </span>
                            </span>

                        }

                        {/* <div className="mt-2 text-secondary fs-12 d-inline-block ps-2">{language?.static_labels.sping_lable_remains}</div> */}
                      </div>
                      : ""
                  }
                </div>
                <div className="text-danger fs-11 mt-3 ps-4 pe-4" style={{ color: "#FF4823", fontSize: "12px" }}>
                  {firstExp ? firstExp : ""}
                </div>

              </div>
              <hr />
              {
                tenant?.tenantmasterconfig.gamification?.show ?
                  <div className="p-3 fs-14 row">

                    <div className="fw-bold col fs-11">
                      {language?.static_labels.total_cashback}
                      <div className="fs-18">{tenant?.tenantmasterconfig.common.currency_symbol}{(cbBaseReward || 0) + (cbBonusReward || 0)}</div>
                    </div>

                    <div className="col">
                      {language?.static_labels.base_cashback} <div className=" fs-18">{tenant?.tenantmasterconfig.common.currency_symbol}{cbBaseReward || 0}</div>
                    </div>

                    <div className="col">
                      {language?.static_labels.bonus_cashback} <div className=" fs-18">{tenant?.tenantmasterconfig.common.currency_symbol}{cbBonusReward || 0}</div>
                    </div>
                  </div>
                  : ""
              }


            </div>

            {/* <hr /> */}

          </div>
        </div>
      </div>


    </div >
  );
}
